export default "__VITE_ASSET__2b5d54f2__"